(function () {
  var instances = {};

  function initShopByCategories(sectionId) {
    var swiperEl = document.getElementById('sbc-swiper-' + sectionId);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    // destroy existing instance before re-init (editor re-render)
    if (instances[sectionId]) {
      instances[sectionId].destroy(true, true);
      instances[sectionId] = null;
    }

    instances[sectionId] = new Swiper(swiperEl, {
      slidesPerView: 6,
      spaceBetween: 44,
      watchOverflow: true,
      navigation: {
        prevEl: '#sbc-prev-' + sectionId,
        nextEl: '#sbc-next-' + sectionId
      },
      breakpoints: {
        0:    { slidesPerView: 1, spaceBetween: 12, centeredSlides: true },
        575:  { slidesPerView: 2, spaceBetween: 16, centeredSlides: false },
        1024: { slidesPerView: 3,   spaceBetween: 20, centeredSlides: false },
        1281: { slidesPerView: 4,   spaceBetween: 30, centeredSlides: false },
        1481: { slidesPerView: 5,   spaceBetween: 30, centeredSlides: false },
        1681: { slidesPerView: 6,   spaceBetween: 44, centeredSlides: false },
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-shop-by-categories]').forEach(function (el) {
      initShopByCategories(el.dataset.shopByCategories);
    });
  }

  // initial load — runs immediately if DOM already ready (editor case)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: section added or re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-shop-by-categories]');
    if (el) initShopByCategories(el.dataset.shopByCategories);
  });

  // Shopify theme editor: block selected — slide it into view
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('[data-shop-by-categories]');
    if (!el) return;
    var sectionId = el.dataset.shopByCategories;
    var sw = instances[sectionId];
    if (sw) {
      var slide = e.target.closest('.swiper-slide');
      if (slide) {
        var index = Array.prototype.indexOf.call(slide.parentNode.children, slide);
        if (index > -1) sw.slideTo(index);
      }
    }
  });
})();